module.exports = __webpack_public_path__ + "static/media/Hover4_Chicago.d8e33d6e.jpg";